import {remCalc} from '_themeUtils'

const editorialWidget = {
    Widget: {
        baseStyle: ({
            backgroundColor,
            backgroundColorCollapsed,
            textColor,
            textColorCollapsed,
            borderColor,
            borderColorCollapsed,
            borderRadius,
            borderWidth,
            borderWidthCollapsed,
            maxWidth,
            maxWidthMobile,
            expanded,
            ratio,
        }: {
            backgroundColor: string
            backgroundColorCollapsed: string
            textColor: string
            textColorCollapsed: string
            borderColor: string
            borderColorCollapsed: string
            borderRadius: string
            borderWidth: string
            borderWidthCollapsed: string
            maxWidth: string
            maxWidthMobile: string
            expanded: boolean
            ratio: string
        }) => ({
            widgetWrapper: {
                position: 'fixed',
                left: `calc(24px + ${expanded ? borderWidth : borderWidthCollapsed})`,
                bottom: `calc(24px + ${expanded ? borderWidth : borderWidthCollapsed})`,
                w: expanded ? {base: maxWidthMobile ? maxWidthMobile : maxWidth, md: maxWidth} : `calc(60px - 2 * ${borderWidthCollapsed})`,
                maxWidth: {base: maxWidthMobile ? maxWidthMobile : maxWidth, md: maxWidth},
                bg: expanded ? backgroundColor : backgroundColorCollapsed,
                borderRadius: borderRadius,
                boxShadow: `0 0 0 ${expanded ? borderWidth : borderWidthCollapsed} ${expanded ? borderColor : borderColorCollapsed}`,
                aspectRatio: expanded ? ratio : '1 / 1',
                overflow: 'hidden',
                zIndex: 300,
                cursor: 'pointer',
                transition: 'width 0.2s',
            },
            widgetLink: {
                w: {base: maxWidthMobile ? maxWidthMobile : maxWidth, md: maxWidth},
                h: '100%',
                transition: 'opacity 0.12s',
                opacity: expanded ? 1 : 0,
                display: 'block',
                pointerEvents: expanded ? 'auto' : 'none',
                position: 'absolute',
                left: 0,
                bottom: 0,
            },
            widgetButton: {
                w: `calc(60px - 2 * ${expanded ? borderWidth : borderWidthCollapsed})`,
                h: `calc(60px - 2 * ${expanded ? borderWidth : borderWidthCollapsed})`,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 0,
                p: 0,
                overflow: 'hidden',
                transition: 'transform 0.18s, opacity 0.12s',
                transform: expanded ? 'translateX(-50%) scale(0.9)' : 'translateX(-50%) scale(1)',
                opacity: expanded ? 0 : 1,
                pointerEvents: expanded ? 'none' : 'auto',
                position: 'absolute',
                left: '50%',
                bottom: 0,
            },
            widgetButtonIconWrapper: {
                h: '50%',
                w: '100%',
                alignItems: 'center',
                justifyContent: 'flex-end',
                pb: remCalc(2),
            },
            widgetButtonIcon: {
                width: '100%',
                height: '100%',
                positionContainer: 'relative',
                position: 'absolute',
                objectFit: 'contain',
            },
            widgetButtonTextWrapper: {
                h: '50%',
                w: '100%',
                alignItems: 'center',
                justifyContent: 'flex-start',
                pt: remCalc(2),
                px: remCalc(6),
            },
            widgetCollapsedText: {
                color: textColorCollapsed,
                fontWeight: 400,
                fontSize: {base: remCalc(14), md: remCalc(16)},
                lineHeight: 1.2,
                textAlign: 'center',
            },
            widgetTextWrapper: {
                position: 'absolute',
                bottom: 0,
                w: '100%',
                h: '50%',
                p: {base: `0 ${remCalc(10)}`, md: `0 ${remCalc(16)}`},
                display: 'flex',
                transition: 'opacity 0.12s',
                opacity: expanded ? 1 : 0,
                visibility: expanded ? 'visible' : 'hidden',
            },
            widgetText: {
                marginTop: 'auto',
                marginBottom: remCalc(16),
                color: textColor,
                fontWeight: 300,
                fontSize: {base: remCalc(11), md: remCalc(16)},
            },
        }),
    },
}

export default editorialWidget
